<template>
  <div class="finance-flex financ-single-tree">
    <div class="info-main">
      <div class="finance-line"></div>
      <div class="info-main-amount">退款申请<div>{{amount | toFenThousandsAndFloat}}</div>元</div>
    </div>
    <div class="info-list">
      <div v-for="(item, index) in listData" :key="index" class="info-list-item">
        <div class="finance-line"></div>
        <div v-if="index === 0" class="finance-top-left-cover-line"></div>
        <div v-if="index === listData.length - 1" class="finance-bottom-left-cover-line"></div>
        <node-content>
          <template #title>
            <div class="finance-flex" style="width: 100%">
              <div class="node-content-title">{{ item.refundWayDesc || '-' }}</div>
              <div class="finance-flex-1 amount">{{ item.refundAmount | toFenThousandsAndFloat('¥') }}</div>
            </div>
          </template>
          <div class="content-cell-list">
            <div class="content-cell finance-flex" v-for="(it, index) in getCellList(item)" :key="index">
              <div>{{it.label}}</div>
              <div class="finance-flex-1">{{item[it.prop] || '-'}}</div>
            </div>
            <div class="arrow-box" @click="handleOpen(item)">
              <i :class="item.opened ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
          </div>
        </node-content>
      </div>
    </div>
  </div>
</template>

<script>
import nodeContent from '../../../../components/node-content';
import * as _ from 'lodash';

export default {
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    amount: {
      type: [Number, String],
      default: 0,
    },
  },
  components: { nodeContent },
  data() {
    return {
      listData: [],
    };
  },
  watch: {
    list: {
      handler() {
        this.$nextTick(() => {
          this.listData = _.cloneDeep(this.list);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getCellList(row) {
      const cell = [];
      const cell2 = [
        { label: '账户类型', prop: 'recAccountTypeDesc' },
        { label: '收款户名', prop: 'recAccountName' },
        { label: '收款账户', prop: 'recAccountNumber' },
        { label: '收款银行', prop: 'recBankName' },
        { label: '支行名称', prop: 'recBankBranchName' },
      ];
      if (row.opened) {
        return [...cell, ...cell2];
      }
      return cell;
    },
    handleOpen(row) {
      this.$set(row, 'opened', !row.opened);
    },
  },
};
</script>

<style scoped lang="scss">
.mb-8 {
  margin-bottom: 8px;
}

.amount {
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FF3741;
  line-height: 20px;
}

.node-content-title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4D4F51;
  line-height: 20px;
}
</style>
